import { formatText, formatVal, valToPercent } from '../../../../helpers/value'

export const DATA_TABLE = {
  activeStatusName: {
    key: 'activeStatusName',
    title: 'industryOverview.businessStatus.OPERATING_STATUS',
    thStyle: {},
    format: (val) => formatText(val),
  },
  numberCompanies: {
    key: 'numberCompanies',
    title: 'industryOverview.businessStatus.NUMBER_OF_COMPANIES',
    thStyle: {
      justifyContent: 'flex-end',
    },
    format: (val, locale) => formatVal(val, locale, false, 0),
  },
  totalPercentCompanies: {
    key: 'totalPercentCompanies',
    title: 'industryOverview.businessStatus.TOTAL_COMPANIES_PERCENT',
    thStyle: {
      justifyContent: 'flex-end',
    },
    format: (val, locale) => valToPercent(val, locale),
  },
}
